import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CommentsSection />
        <CarouselSection />
        <IndexSection />
        <AppSection />
        <AboutSection />
        <TopicsSection />
        <RankingSection />
        <FAQSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}